/** CR-10 payment terms options for Add/Edit client Billing Details. */
export const PAYMENT_TERMS_OPTIONS = [
  { label: '1 Day', value: '1_DAY' },
  { label: '3 Days', value: '3_DAYS' },
  { label: '1 Week', value: '1_WEEK' },
  { label: '2 Weeks', value: '2_WEEKS' },
  { label: '1 Month', value: '1_MONTH' },
  { label: '2 Months', value: '2_MONTHS' },
] as const;

/** Current + legacy codes for read-only display. */
export const PAYMENT_TERMS_LABELS: Record<string, string> = {
  '1_DAY': '1 Day',
  '3_DAYS': '3 Days',
  '1_WEEK': '1 Week',
  '2_WEEKS': '2 Weeks',
  '1_MONTH': '1 Month',
  '2_MONTHS': '2 Months',
  COD: 'COD',
  '7_DAYS': '7 Days',
  '14_DAYS': '14 Days',
  '30_DAYS': '30 Days',
  '60_DAYS': '60 Days',
};

export function paymentTermsLabel(code: string | null | undefined): string {
  if (!code) return '—';
  return PAYMENT_TERMS_LABELS[code] || String(code);
}
